export default __webpack_public_path__ + "static/media/budget-country-display.916d0666.png";